export default {"src":"/_next/static/media/yard-functional.858885c0.svg","height":20,"width":25,"blurWidth":0,"blurHeight":0};